"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var styled_1 = __importDefault(require("@emotion/styled"));
var react_1 = __importStar(require("react"));
var _1 = __importDefault(require("."));
var Background = styled_1.default.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    background: linear-gradient(rgba(0, 0, 0, 0), rgba(18, 18, 18, 0.6));\n    cursor: default;\n    position: absolute;\n    bottom: 0;\n    left: 0;\n    right: 0;\n    height: 75px;\n    pointer-events: none;\n"], ["\n    background: linear-gradient(rgba(0, 0, 0, 0), rgba(18, 18, 18, 0.6));\n    cursor: default;\n    position: absolute;\n    bottom: 0;\n    left: 0;\n    right: 0;\n    height: 75px;\n    pointer-events: none;\n"])));
var Attribution = (0, styled_1.default)(_1.default)(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n    position: absolute;\n    bottom: 10px;\n    left: 10px;\n    right: 10px;\n"], ["\n    position: absolute;\n    bottom: 10px;\n    left: 10px;\n    right: 10px;\n"])));
var Container = styled_1.default.div(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n    transition: opacity 150ms ease-in;\n"], ["\n    transition: opacity 150ms ease-in;\n"])));
var AttributionOverlay = function (_a) {
    var gif = _a.gif, isHovered = _a.isHovered, onClick = _a.onClick;
    var hasHovered = (0, react_1.useRef)(isHovered);
    if (isHovered) {
        // not rendering to avoid loading the avatar until hover
        hasHovered.current = true;
    }
    return gif.user && hasHovered.current ? (react_1.default.createElement(Container, { style: { opacity: isHovered ? 1 : 0 } },
        react_1.default.createElement(Background, null),
        react_1.default.createElement(Attribution, { gif: gif, onClick: onClick }))) : null;
};
exports.default = AttributionOverlay;
var templateObject_1, templateObject_2, templateObject_3;
//# sourceMappingURL=overlay.js.map